import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import { ScenarioDetailTableProvider } from './ScenarioSelectionDetailedSummary/ScenarioDetailTableContext';
import ScenarioSelectionDetailedSummary from './ScenarioSelectionDetailedSummary/ScenarioSelectionDetailedSummary';

const ScenarioSelectionDetailedSummaryPicker = ({ resource }) => {
  return pick(resource, {
    [fr.relationships.detailedSummary.name]: (
      <ScenarioDetailTableProvider relationship={resource.relationship(fr.relationships.detailedSummary.name)}>
        <ScenarioSelectionDetailedSummary />
      </ScenarioDetailTableProvider>
    ),
  }, null);
};

ScenarioSelectionDetailedSummaryPicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
ScenarioSelectionDetailedSummaryPicker.defaultProps = {
};

export default ScenarioSelectionDetailedSummaryPicker;
